export const ScreenSize = {
  mobileScreen: "320px",
  tabletScreen: "768px",
  laptopScreen: "992px",
  desktopScreen: "1400px",
};
